import UserBoard from "@svg/new-design/user-board";
import classNames from "classnames";
import { FC } from "react";
import { IInstructor } from "./types";

interface Props {
  instructor: IInstructor[] | undefined;
  hugElement: boolean;
  showTeacher: boolean;
}
const CardInstructor: FC<Props> = ({ instructor, hugElement, showTeacher }) => {
  const instructorName = instructor
    ? instructor.length === 1
      ? `${instructor[0]?.first_name}  ${instructor[0]?.last_name}`
      : "مشارکتی"
    : "";

  const instructorIcon = instructor ? (
    <UserBoard className="h-4 md:h-fds-18 w-4 md:w-fds-18" fill="#52565C" />
  ) : null;
  const renderInstructor = Boolean(instructorName && showTeacher);

  return (
    <div className={classNames("flex md:gap-1.5  gap-1 ")}>
      {renderInstructor ? instructorIcon : null}
      <p className="text-fds-secondary body-xxsm md:body-xsm line-clamp-1">
        {showTeacher ? (
          renderInstructor ? (
            instructorName
          ) : !hugElement ? (
            <br />
          ) : null
        ) : null}
      </p>
    </div>
  );
};

export default CardInstructor;
